const InstructionsPage = () => {
  return (
    <div className="info-page">
      <div className="info-page__header">
        <h1 className="info-page__title">Instructions</h1>
        <p className="info-page__subtitle">How to trade gold on milligram.tv</p>
      </div>

      <div className="info-page__sections">
        <section className="info-page__section">
          <div className="info-page__step-number">1</div>
          <h3>Connect Your Wallet</h3>
          <p>
            Click the <strong>Connect</strong> button in the top-right corner and approve the
            MetaMask connection. Make sure you are on the Sepolia testnet or Ethereum mainnet.
          </p>
        </section>

        <section className="info-page__section">
          <div className="info-page__step-number">2</div>
          <h3>Deposit Tokens</h3>
          <p>
            Open your <strong>Profile</strong> menu and navigate to <strong>Balance</strong>.
            Deposit PAXG, USDT, ETH, or other supported tokens from your wallet into the exchange.
          </p>
        </section>

        <section className="info-page__section">
          <div className="info-page__step-number">3</div>
          <h3>Place Orders</h3>
          <p>
            Use <strong>Buy / Sell</strong> from the profile menu to create limit orders.
            Select the token pair, enter the amount, and confirm. Your order will appear in
            the Order Book.
          </p>
        </section>

        <section className="info-page__section">
          <div className="info-page__step-number">4</div>
          <h3>Use the Gold Vault</h3>
          <p>
            Mint <strong>MG</strong> (Milligram) tokens by locking PAXG in the Gold Vault at a
            rate of 1 PAXG = 31,103.5 MG. Use MGTV governance tokens for a 10x fee discount.
            You can redeem MG back to PAXG at any time.
          </p>
        </section>

        <section className="info-page__section">
          <div className="info-page__step-number">5</div>
          <h3>Monitor & Withdraw</h3>
          <p>
            Track your open orders in the <strong>Orders</strong> tab. View completed trades
            in <strong>My Transactions</strong>. When ready, withdraw your tokens back to
            your wallet from the <strong>Balance</strong> page.
          </p>
        </section>
      </div>
    </div>
  )
}

export default InstructionsPage
